import { render, staticRenderFns } from "./citizenRouterViewWrapper.vue?vue&type=template&id=f9a9482e"
import script from "./citizenRouterViewWrapper.vue?vue&type=script&lang=js"
export * from "./citizenRouterViewWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-1e9da41bb0/5/Users/asauder/AppData/Local/Yarn/Berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports